"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconButtonSlots = exports.default = exports.IconButton = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _utils = require("../utils");
var _iconButtonClasses = require("./iconButtonClasses");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable complexity -- many options */

const getIconButtonSlots = ownerState => {
  const {
    color,
    size,
    variant,
    loading,
    edge
  } = ownerState;
  return {
    root: ['root', loading && 'loading', variant, `size${(0, _utils.capitalize)(size)}`, `color${(0, _utils.capitalize)(color)}`, (edge === 'end' || edge === 'start') && `edge${(0, _utils.capitalize)(edge)}`],
    loadingIndicator: ['loadingIndicator'],
    loadingWrapper: ['loadingWrapper']
  };
};
exports.getIconButtonSlots = getIconButtonSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getIconButtonSlots(ownerState);
  const composedClasses = (0, _base.unstable_composeClasses)(slots, _iconButtonClasses.getIconButtonUtilityClass, classes);
  return {
    ...classes,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...composedClasses
  };
};
const IconButtonRoot = (0, _material.styled)(_material.ButtonBase, {
  name: 'MuiOriIconButton',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.root, styles[ownerState.variant], styles[`color${(0, _utils.capitalize)(ownerState.color)}`], styles[`size${(0, _utils.capitalize)(ownerState.size)}`], ownerState.loading && styles.loading, (ownerState.edge === 'end' || ownerState.edge === 'start') && styles[`edge${(0, _utils.capitalize)(ownerState.edge)}`]],
  shouldForwardProp: prop => (0, _utils.rootShouldForwardProp)(prop) || prop === 'classes'
})(({
  theme,
  ownerState
}) => ({
  textAlign: 'center',
  flex: '0 0 auto',
  fontSize: '2.4rem',
  padding: 6,
  borderRadius: '50%',
  boxShadow: 'none',
  minHeight: 24,
  minWidth: 24,
  width: 'fit-content',
  height: 'fit-content',
  color: theme.palette.action.active,
  transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
    duration: theme.transitions.duration.short
  }),
  ...(ownerState.edge === 'start' && {
    marginLeft: -12
  }),
  ...(ownerState.edge === 'end' && {
    marginRight: -12
  }),
  ...(ownerState.size === 'small' && {
    padding: 3,
    fontSize: '1.8rem',
    ...(ownerState.edge === 'start' && {
      marginLeft: -3
    }),
    ...(ownerState.edge === 'end' && {
      marginRight: -3
    })
  }),
  ...(ownerState.size === 'large' && {
    padding: 9,
    fontSize: '2.7rem'
  }),
  ...(ownerState.variant === 'contained' && {
    color: theme.palette.default.contrastText,
    background: theme.palette.default.dark,
    boxShadow: 'none',
    '&:hover': {
      color: theme.palette.default.contrastText,
      background: theme.palette.grey.A700,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        background: theme.palette.default.dark
      }
    },
    '&:focus': {
      color: theme.palette.default.contrastText
    },
    ...(ownerState.disableFocusRipple && {
      '&:focus-visible': {
        color: theme.palette.default.contrastText,
        outline: `2px solid ${theme.palette.common.white}`,
        outlineOffset: -4
      }
    }),
    ...(ownerState.color === 'error' && {
      color: theme.palette.error.contrastText,
      background: theme.palette.error.main,
      '&:hover': {
        color: theme.palette.error.contrastText,
        background: theme.palette.error.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          background: theme.palette.error.main
        }
      },
      '&:focus': {
        color: theme.palette.error.contrastText
      }
    }),
    ...(ownerState.color === 'secondary' && {
      backgroundColor: theme.palette.grey[100],
      color: theme.palette.text.primary,
      '&:hover': {
        color: theme.palette.text.primary,
        backgroundColor: (0, _material.alpha)(theme.palette.default.main, 0.12),
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[100]
        }
      },
      '&:focus': {
        color: theme.palette.text.primary
      }
    }),
    ...((ownerState.disabled || ownerState.loading) && {
      background: theme.palette.grey[200],
      color: theme.palette.grey.A400
    }),
    ...(ownerState.color === 'default' && {
      color: theme.palette.default.main,
      background: theme.palette.default.contrastText,
      boxShadow: theme.shadows[2],
      '&:hover': {
        color: theme.palette.default.main,
        background: theme.palette.default.contrastText,
        boxShadow: theme.shadows[3],
        '@media (hover: none)': {
          boxShadow: theme.shadows[2],
          background: theme.palette.default.contrastText
        }
      },
      '&:focus': {
        color: theme.palette.default.main
      },
      '&:focus-visible': {
        color: theme.palette.default.main,
        boxShadow: theme.shadows[6]
      },
      ...((ownerState.disabled || ownerState.loading) && {
        color: theme.palette.grey[400],
        background: theme.palette.default.contrastText,
        boxShadow: theme.shadows[2]
      })
    })
  }),
  ...(ownerState.variant === 'outlined' && {
    padding: 4,
    border: '1px solid currentColor',
    borderColor: theme.palette.default.dark,
    color: theme.palette.default.dark,
    background: 'transparent',
    '&:hover': {
      color: theme.palette.default.dark,
      borderColor: theme.palette.default.dark,
      background: (0, _material.alpha)(theme.palette.default.main, 0.12),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        background: 'transparent'
      }
    },
    '&:focus': {
      color: theme.palette.default.dark
    },
    '&:active': {
      background: (0, _material.alpha)(theme.palette.default.main, 0.12)
    },
    ...(ownerState.color === 'inherit' && {
      color: 'inherit',
      borderColor: 'currentColor',
      '&:hover': {
        color: theme.palette.common.white,
        background: theme.palette.grey.A700,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          color: 'inherit',
          background: 'transparent'
        }
      },
      '&:active': {
        color: theme.palette.common.white,
        background: theme.palette.grey.A700
      }
    }),
    ...(ownerState.color === 'error' && {
      borderColor: theme.palette.error.dark,
      color: theme.palette.error.dark,
      '&:hover': {
        color: theme.palette.error.dark,
        background: (0, _material.alpha)(theme.palette.error.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          background: 'transparent'
        }
      },
      '&:focus': {
        color: theme.palette.error.dark
      },
      '&:active': {
        background: (0, _material.alpha)(theme.palette.error.main, theme.palette.action.hoverOpacity)
      }
    }),
    ...(ownerState.color === 'secondary' && {
      borderColor: (0, _material.alpha)(theme.palette.default.contrastText, 0.75),
      background: (0, _material.alpha)(theme.palette.default.contrastText, 0.75),
      color: theme.palette.default.dark,
      '&:hover': {
        borderColor: (0, _material.alpha)(theme.palette.default.dark, 0.08),
        background: (0, _material.alpha)(theme.palette.default.dark, 0.08),
        color: theme.palette.default.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          borderColor: (0, _material.alpha)(theme.palette.default.contrastText, 0.75),
          background: (0, _material.alpha)(theme.palette.default.contrastText, 0.75),
          color: theme.palette.default.dark
        }
      },
      '&:focus': {
        color: theme.palette.default.dark
      },
      '&:active': {
        background: (0, _material.alpha)(theme.palette.default.dark, 0.08)
      }
    }),
    ...(ownerState.size === 'small' && {
      padding: 2
    }),
    ...(ownerState.size === 'large' && {
      padding: 8
    }),
    ...((ownerState.disabled || ownerState.loading) && {
      background: theme.palette.grey[200],
      color: theme.palette.grey.A400,
      borderColor: theme.palette.grey[200]
    }),
    ...(ownerState.disableFocusRipple && {
      '&:focus-visible': {
        outline: `2px solid ${theme.palette.default.dark}`,
        outlineOffset: -2,
        backgroundColor: (0, _material.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
      }
    })
  }),
  ...(ownerState.variant === 'text' && {
    color: theme.palette.default.main,
    backgroundColor: 'transparent',
    '&:hover': {
      color: theme.palette.default.main,
      background: (0, _material.alpha)(theme.palette.default.main, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        background: 'transparent'
      }
    },
    '&:focus': {
      color: theme.palette.default.main
    },
    '&:active': {
      background: (0, _material.alpha)(theme.palette.default.main, theme.palette.action.hoverOpacity)
    },
    ...(ownerState.color === 'error' && {
      color: theme.palette.error.dark,
      '&:hover': {
        color: theme.palette.error.dark,
        background: (0, _material.alpha)(theme.palette.error.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          background: 'transparent'
        }
      },
      '&:focus': {
        color: theme.palette.error.dark
      },
      '&:active': {
        background: (0, _material.alpha)(theme.palette.error.main, theme.palette.action.hoverOpacity)
      }
    }),
    ...(ownerState.color === 'inherit' && {
      color: 'inherit',
      '&:hover': {
        color: theme.palette.common.white,
        background: theme.palette.grey.A700,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          color: 'inherit',
          background: 'transparent'
        }
      },
      '&:active': {
        color: theme.palette.common.white,
        background: theme.palette.grey.A700
      }
    }),
    ...((ownerState.disabled || ownerState.loading) && {
      background: 'transparent',
      color: theme.palette.grey.A400
    }),
    ...(ownerState.disableFocusRipple && {
      '&:focus-visible': {
        outline: `1px solid ${theme.palette.default.dark}`,
        outlineOffset: -1
      }
    })
  }),
  ...(ownerState.loading && {
    color: 'transparent'
  })
}));
const IconButtonLoadingIndicator = (0, _material.styled)('span', {
  name: 'MuiOriIconButton',
  slot: 'LoadingIndicator',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.loadingIndicator]
})(({
  theme,
  ownerState
}) => ({
  display: 'none',
  position: 'absolute',
  visibility: 'visible',
  ...(ownerState.loading && {
    display: 'flex'
  }),
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  color: theme.palette.action.disabled
}));
const getIcon = ({
  children,
  hoverIcon,
  isHovering
}) => {
  if (Boolean(hoverIcon) && isHovering) {
    return hoverIcon;
  }
  return children;
};
const IconButton = exports.IconButton = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _material.useThemeProps)({
    props: inProps,
    name: 'MuiOriIconButton'
  });
  const {
    children,
    className,
    color = 'primary',
    dataTestId,
    disabled = false,
    disableFocusRipple = false,
    edge = false,
    focusVisibleClassName,
    hoverIcon,
    id: idProp,
    loading = null,
    size = 'medium',
    type,
    variant = 'outlined',
    ...other
  } = props;
  const loadingId = (0, _material.unstable_useId)(idProp);
  const loaderSize = (0, _react.useMemo)(() => {
    if (size === 'small') {
      return '1.4rem';
    }
    if (size === 'large') {
      return '2.3rem';
    }
    return '2rem';
  }, [size]);
  const loadingIndicator = (0, _react.useMemo)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {
    "aria-labelledby": loadingId,
    color: "inherit",
    size: loaderSize
  }), [loadingId, loaderSize]);
  const [isHovering, setIsHovering] = (0, _react.useState)(false);
  const handleMouseOver = (0, _react.useCallback)(() => {
    setIsHovering(true);
  }, []);
  const handleMouseOut = (0, _react.useCallback)(() => {
    setIsHovering(false);
  }, []);
  const ownerState = (0, _react.useMemo)(() => ({
    ...props,
    color,
    disabled,
    disableFocusRipple,
    edge,
    size,
    type,
    variant
  }), [color, disabled, disableFocusRipple, edge, props, size, type, variant]);
  const classes = useUtilityClasses(ownerState);
  const loader = (0, _react.useMemo)(() => {
    if (typeof loading === 'boolean') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
          display: 'contents'
        },
        children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(IconButtonLoadingIndicator, {
          className: classes.loadingIndicator,
          ownerState: ownerState,
          children: loadingIndicator
        }) : null
      });
    }
    return null;
  }, [classes.loadingIndicator, classes.loadingWrapper, loading, loadingIndicator, ownerState]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(IconButtonRoot, {
    ref: ref,
    centerRipple: true,
    className: (0, _clsx.default)(classes.root, className),
    disabled: disabled || (loading ?? false),
    focusRipple: !disableFocusRipple,
    id: loading ? loadingId : idProp,
    "data-testid": dataTestId,
    onMouseOver: handleMouseOver,
    onMouseOut: handleMouseOut,
    ...other,
    ownerState: ownerState,
    children: [loader, getIcon({
      children,
      hoverIcon,
      isHovering
    })]
  });
});
var _default = exports.default = IconButton;
